/** Site-wide settings that aren't secrets. */
export const SITE = {
  name: 'ChessBut',
  url: 'https://chessbut.app',
  /** Instagram profile URL; the footer link hides while this is null. */
  instagram: null as string | null,
  studio: { name: 'TechTy Studio', url: 'https://techty.app' },
};
